import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { GoogleMapsModule } from '@angular/google-maps';
import { SharedComponentModule } from "../shared/components/shared-component.module";
import { I18nModule } from "../i18n/i18n.module";
import { clientConfig } from "../shared/constant/app.constant";
import { DesktopComponent } from "./desktop.component";
import { DLandingPageComponent } from "./d-landing-page/d-landing-page.component";
import { StartComponent } from "./d-landing-page/start/start.component";
import { ReturnItemsComponent } from "./d-landing-page/return-items/return-items.component";
import { ReturnOptionsComponent } from "./d-landing-page/return-options/return-options.component";
import { ConfirmComponent } from "./d-landing-page/confirm-return/confirm-return.component";
import { ReturnComponent } from "./d-landing-page/return/return.component";
import { ReturnItemsDetailsComponent } from "./d-landing-page/return-items/return-order-details/return-items-details.component";
import { UpdateComponent } from "./d-landing-page/return-options/update-address/update-address.component";
import { RetunOrderLoginComponent } from "./d-landing-page/retun-order-login/retun-order-login.component";
import { CancelorderComponent } from "./d-landing-page/cancelorder/cancelorder.component";
import { TechSupportComponent } from "./d-landing-page/tech-support/tech-support.component";
import { CustomerServiceCaseComponent } from './d-landing-page/customer-service-case/customer-service-case.component';

@NgModule({
  declarations: [
    DesktopComponent,
    DLandingPageComponent,
    StartComponent,
    ReturnItemsComponent,
    ReturnOptionsComponent,
    ConfirmComponent,
    ReturnComponent,
    ReturnItemsDetailsComponent,
    UpdateComponent,
    RetunOrderLoginComponent,
    CancelorderComponent,
    CustomerServiceCaseComponent,
    TechSupportComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    SharedComponentModule,
    NgbModule,
    I18nModule,
    GoogleMapsModule
  ],
  exports: [DesktopComponent],
  providers: [],
})
export class DesktopModule {}
